/**
 * The composer's caret on phones.
 *
 * On a desktop, a layout change that shows the panel puts the caret in the
 * composer so the visitor can start typing. On a phone, focus RAISES THE
 * SOFTWARE KEYBOARD, and layouts change for reasons that are not typing:
 * voice starting, the avatar going live, an Action opening the sheet.
 * David's Lumina test (2026-10-21): the keyboard stayed up into voice,
 * and with the video avatar it pushed the face above the viewport. So on
 * phones a layout change never focuses the composer (a visitor who was
 * already typing keeps focus — the field is the same element across
 * layouts), and a live call dismisses the keyboard.
 *
 * Positional arguments on purpose: the main bundle sits at its gzip gate.
 */

export function focusComposerOnLayout(next: string, icon: string, isFirstCall: boolean, phone: boolean): boolean {
  return !isFirstCall && next !== icon && !phone;
}

/** Drop the keyboard: blur whatever holds focus (a button losing focus as a call starts is harmless). */
export function dismissKeyboard(doc: Document): void {
  const el = doc.activeElement;
  if (el instanceof HTMLElement) el.blur();
}
